module.exports = __webpack_public_path__ + "static/media/File-filled.e9a53eb6.svg";